<!--
  @Description: 购票
  @Author: wang.y 
  @Date: 2024-07-27 
-->
<template>
  <div>
    <div class="skeleton-warpper" v-if="pageLoading">
      <van-skeleton title :row="5" />
    </div>
    <div class="main-container" v-else>
      <page-header>{{'获取门票' | dealLanguage('Get tickets')}}</page-header>
      <div class="center-wrapper">
        <div class="top-tip">
          您好，感谢您关注<span>{{activityDetail.name}}</span>！<br />
          本届展会采用展前“线上预约登记”及现场核验“参会凭证”形式，请务必携带电子参会凭证或打印版参会凭证参会。<br />
          如有任何问题，敬请电话咨询：<span>13372677093 王先生</span>。
        </div>
        <div class="form-view">
          <Form ref="current-form" :model="currentForm" :rules="ruleValidate2">
            <div class="view-title">
              <div class="title">{{'身份信息' | dealLanguage('Identity Imfomation')}}</div>
              <div class="line"></div>
              <!-- <div class="companions">
                <Checkbox v-model="partnerSingle" @on-change="handleChangeSingle">{{'帮他人获取门票' | dealLanguage('Get Tickets for Others')}}</Checkbox>
                <Select v-model="currentPartnerId" size="small" style="width:140px" :placeholder="'请选择同行人' | dealLanguage('Please select')" v-if="partnerSingle" @on-change="handleChangePartner">
                  <Option v-for="item in partnerList" :value="item.id" :key="item">{{ item.name }}</Option>
                </Select>
              </div> -->
            </div>
            <FormItem prop="mobile" :label="'手机号码' | dealLanguage('Phone Number')" v-if="partnerSingle">
              <div class="mobile-ipt">
                <span :class="['area-number', currentPartnerId && 'dis']" @click="handleShowPicker">+{{currentForm.mobileAreaCode}} &gt;</span>
                <Input type="text" :disabled="currentPartnerId" v-model="currentForm.mobile" :placeholder="'请输入手机号' | dealLanguage('Please enter mobile phone number')" autocomplete="off"></Input>
              </div>
            </FormItem>
            <FormItem prop="mobileVerifyCode" :label="'验证码' | dealLanguage('Phone Code')" v-if="!currentPartnerId && partnerSingle">
              <Input type="text" class="code-ipt" v-model="currentForm.mobileVerifyCode" :placeholder="'请填写验证码' | dealLanguage('Please fill in the verification code')"></Input>
              <Captcha ref="captcha" scene="vbdata_bidingmobile" :mobile="currentForm.mobile" :mobileAreaCode="currentForm.mobileAreaCode"></Captcha>
            </FormItem>
            <FormItem prop="name" :label="'姓名' | dealLanguage('Name')">
              <Input type="text" v-model="currentForm.name" :placeholder="'请填写姓名' | dealLanguage('Please fill in your name')"></Input>
            </FormItem>
            <FormItem prop="compName" :label="'公司' | dealLanguage('Company Name')">
              <div class="input-tag">
                <AutoComplete v-model="entityKeyword" :placeholder="!currentForm.entityId ? filter.dealLanguage('请搜索并选择公司', 'Please search and select a company') : ''" @on-search="handleSearchEntity" @on-select="handleSelectEntity" @on-change="handleChangeEntity">
                  <Option v-for="item in entityList" :value="item.id" :key="item.id">
                    <div class="title">
                      {{item.shortName}}
                    </div>
                    <div class="desc">
                      {{item.description}}
                    </div>
                  </Option>
                </AutoComplete>
                <div class="tag-div" v-if="currentForm.entityId">
                  <Tag closable @on-close="handleClose" color="blue">{{currentForm.compName}}</Tag>
                </div>
              </div>
            </FormItem>
            <Row :gutter="10">
              <Col span="12">
              <FormItem prop="department" :label="'部门' | dealLanguage('Department')">
                <Input type="text" v-model="currentForm.department" :placeholder="'请填写部门' | dealLanguage('Please fill in the department')"></Input>
              </FormItem>
              </Col>
              <Col span="12">
              <FormItem prop="title" :label="'职位' | dealLanguage('Position')">
                <Input type="text" v-model="currentForm.title" :placeholder="'请填写职位' | dealLanguage('Please fill in the position')"></Input>
              </FormItem>
              </Col>
            </Row>
            <FormItem prop="companyNatureId" :label="'请问贵公司性质' | dealLanguage('Type of Company')">
              <treeselect v-model="currentForm.companyNatureId" :disableBranchNodes="true" :placeholder="'请选择' | dealLanguage('Please select')" :options="companyNatureTree" @input="handleChangeNT($event, 0)" />
            </FormItem>
            <FormItem prop="companyNatureOtherTagName" :label="compNTother" v-if="compNTother">
              <Input type="text" v-model="currentForm.companyNatureOtherTagName" :placeholder="'请填写具体性质' | dealLanguage('Please fill in the specific nature')"></Input>
            </FormItem>
            <FormItem prop="forums" :label="'您需要参加同期的以下哪些会议及活动（多选）' | dealLanguage('Which of the following conferences and events do you need to attend during the same period？(multi-select)')">
              <CheckboxGroup v-model="currentForm.forums">
                <Checkbox :label="item" v-for="item,index in forums" :key="index"></Checkbox>
              </CheckboxGroup>
            </FormItem>
            <!-- <div class="view-title">
              <div class="title"><span class="red">*</span>{{'您对本次展会哪些领域感兴趣？（多选）' | dealLanguage('What areas are you interested in at this exhibition？(multi-select)')}}</div>
              <div class="line"></div>
            </div>
            <FormItem prop="exhibition">
              <CheckboxGroup v-model="currentForm.exhibition">
                <Checkbox :label="item" v-for="item,index in exhibitionList" :key="index"></Checkbox>
              </CheckboxGroup>
            </FormItem> -->
            <div class="view-title">
              <div class="title"><span class="red">*</span>{{'您参加本次大会最想实现的需求是（请选出最重要的3项）' | dealLanguage('What is your most desired requirement for attending this conference?(Please select the three most important items)')}}</div>
              <div class="line"></div>
            </div>
            <FormItem prop="need">
              <CheckboxGroup v-model="currentForm.need" @on-change="handleChangeNeed">
                <Checkbox :label="item" v-for="item,index in needList" :key="index"></Checkbox>
              </CheckboxGroup>
            </FormItem>
            <FormItem prop="needother" v-if="needother">
              <Input type="text" v-model="currentForm.needother" :placeholder="'请填写具体需求' | dealLanguage('Please fill in the specific requirements')"></Input>
            </FormItem>
            <div class="view-title">
              <div class="title"><span class="red">*</span>{{'您是否需要商贸对接服务？' | dealLanguage('Do you need business matching services?')}}</div>
              <div class="line"></div>
            </div>
            <FormItem prop="service">
              <RadioGroup v-model="currentForm.service" @on-change="handleChangeService">
                <Radio :label="item" v-for="item,index in serviceList" :key="index"></Radio>
              </RadioGroup>
            </FormItem>
            <FormItem prop="serviceother" v-if="serviceother">
              <Input type="text" v-model="currentForm.serviceother" :placeholder="'请填写具体服务内容' | dealLanguage('Please fill in the specific service content')"></Input>
            </FormItem>
            <div class="view-title">
              <div class="title">{{'请选择门票类型' | dealLanguage('Please select the ticket type')}}</div>
              <div class="line"></div>
            </div>
            <FormItem prop="activityTicketId">
              <div class="ticket-list">
                <RadioGroup v-model="currentForm.activityTicketId" @on-change="handleSeletTicket">
                  <Radio :label="item.id" v-for="item,index in ticketList" :key="index">
                    <div class="ticket-item ticket-container">
                      <div class="ticket-item-top">
                        <div class="ticket-item-top-left">
                          <img :src="item.activityShareImagePath | logo_show" />
                          <!-- <img :src="item.activityLogoPath | logo_show" /> -->
                        </div>
                        <div class="ticket-item-top-right">
                          <div>
                            <div class="title">{{item.title | dealLanguage(item.enTitle)}}</div>
                            <div class="desc" v-html="item.remark" v-if="item.remark && language == 'zh'"></div>
                            <div class="desc" v-html="item.enRemark" v-if="item.enRemark && language == 'en'"></div>
                          </div>
                          <div class="price" v-if="item.price">￥{{item.price | amount_show}}</div>
                          <div class="price" v-else>{{'免费' | dealLanguage('FREE')}}</div>
                        </div>
                      </div>
                    </div>
                  </Radio>
                </RadioGroup>
              </div>
            </FormItem>
          </Form>
          <div class="view-title">
            <div class="title">{{'支付信息' | dealLanguage('Payment imformation')}}</div>
            <div class="line"></div>
          </div>
          <div class="pay-type-btn">
            <div class="pay-info">
              <img :src="static_img_url + 'pic/wechat-icon.png?v=' + $store.state.imgVersion" />
              <span class="sp1">{{'微信支付' | dealLanguage('WeChat Pay')}}</span>
              <span class="sp2">{{'线上立即支付' | dealLanguage('Online payment immediately')}}</span>
            </div>
            <img :src="static_img_url + 'pic/select.png?v=' + $store.state.imgVersion" class="select" />
          </div>
        </div>
      </div>
      <div class="btn-wrapper">
        <div class="info">
          <template v-if="this.currentTicket.id">
            <div class="info-p1">{{'门票价格：' | dealLanguage('Ticket price')}}<span>￥{{this.currentTicket.price | amount_show}}</span></div>
            <div class="info-p2" v-if="this.currentTicket.price">{{'您需支付' | dealLanguage('You need to pay ')}}￥{{this.currentTicket.price | amount_show}}{{'用以支付当前门票' | dealLanguage(' to pay for the current ticket')}}</div>
            <div class="info-p2" v-else>{{'您不需要支付' | dealLanguage("You don't have to pay")}}</div>
          </template>
        </div>
        <Button type="primary" @click="submit" :loading="buttonLoading">
          <span v-if="buttonLoading">{{'提交中' | dealLanguage('Loading')}}</span>
          <span v-else>{{'获取门票' | dealLanguage('Get ticket now')}}</span>
        </Button>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker :default-index="defaultIndex" show-toolbar :columns="appMobileAreaCodeDtos" @confirm="onConfirm" @cancel="showPicker = false" value-key="name">
        <template #option="item">
          <div>+{{item.mobileAreaCode}} ({{item.countryName}})</div>
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>
<script>
import PageHeader from '@/components/mobile/pageHeader.vue'
import { Agetmeta, Auserinfo } from '@/service/app'
import {
  getTicketList,
  vbefGenOrder,
  genOpenidByWechatCode,
  orderStatus,
  getPartnerList,
} from '@/service/vbef'
import activityArr from 'js/activityArr'
import buildTree from 'js/buildTree'
import { searchEntity } from 'js/searchEntity'
import { mapState } from 'vuex'
import { signUpMixins } from '@/assets/js/signUpMixins'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { loginCommon } from '@/assets/js/login'
import filter from 'js/filter'
import Captcha from '@/components/common/captcha'
const MOBILE_REGEX = /^1[3-9]\d{9}$/
export default {
  metaInfo() {
    return {
      title: filter.dealLanguage('获取门票', 'Get tickets'),
    }
  },
  inject: ['login', 'wxShare'],
  mixins: [searchEntity, loginCommon, signUpMixins],
  components: {
    PageHeader,
    Treeselect,
    Captcha,
  },
  created() {
    this.Agetmeta()
    this.getTicketList()
    // this.getPartnerList()
  },
  mounted() {
    this.wxShare({
      title: filter.dealLanguage('获取门票-2025VB100大会', 'Get tickets-2025VB100 Conference'),
      linkurl: this.vbef_path + '/signUp',
    })
    // 判断是否微信浏览器
    if (this.isWeixinBrowser) {
      if (!this.$route.query.code && !this.wxCode) {
        let currentHref = `${this.index2_path}/home/wxMiddleware?language=${this.language}`
        currentHref = encodeURIComponent(currentHref)
        let link = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.wxAppId}&redirect_uri=${currentHref}&response_type=code&scope=snsapi_base&state=1#wechat_redirect`
        window.location.href = link
        return
      }
      if (this.$route.query.code) {
        this.wxCode = this.$route.query.code
      }
      this.checkAndInitBridge()
    } else {
      if (this.$route.query.pay_status) {
        this.payOrderId = this.$route.query.order_id
        this.orderStatus()
      }
    }
    this.pageLoading = false

    if (!this.user_key) {
      this.login(this.ininUserInfo)
    } else {
      this.ininUserInfo()
    }
  },
  beforeDestroy() {
    clearInterval(this.orderInv)
    // 组件销毁前，移除事件监听器
    if (document.removeEventListener) {
      document.removeEventListener('WeixinJSBridgeReady', this.onBridgeReady)
    } else if (document.detachEvent) {
      document.detachEvent('WeixinJSBridgeReady', this.onBridgeReady)
      document.detachEvent('onWeixinJSBridgeReady', this.onBridgeReady)
    }
  },
  data() {
    return {
      filter,
      pageLoading: true,
      buttonLoading: false,
      wxCode: '',
      wxAppId: 'wx93f12cd83e68833d',
      orderInv: 0,
      payOrderId: '',
      showPicker: false,
    }
  },
  methods: {
    ininUserInfo() {
      if (this.partnerSingle) {
        this.currentForm.name = ''
        this.currentForm.compName = ''
        this.entityKeyword = ''
        this.currentForm.entityId = 0
        this.currentForm.department = ''
        this.currentForm.title = ''
        this.currentForm.companyNatureId = null
        this.currentForm.companyNatureOtherTagName = ''
        this.currentForm.mobile = ''
        this.currentForm.mobileAreaCode = '86'
        this.currentForm.mobileVerifyCode = ''
        return
      }
      const user = this.$store.state.user
      this.currentForm.name = user.name || ''
      this.currentForm.compName = user.compName || ''
      this.entityKeyword = user.compName || ''
      this.currentForm.entityId = user.entityId || 0
      this.currentForm.department = user.department || ''
      this.currentForm.title = user.title || ''
      this.currentForm.companyNatureId = user.companyNatureId || null
      this.currentForm.companyNatureOtherTagName = user.companyNatureOtherTagName || ''
      this.currentForm.mobile = ''
      this.currentForm.mobileAreaCode = '86'
      this.currentForm.mobileVerifyCode = ''
      if (this.wxCode) this.genOpenidByWechatCode()
    },
    handleShowPicker() {
      if (this.currentPartnerId) return
      this.showPicker = true
    },
    onConfirm(item) {
      this.currentForm.mobileAreaCode = item.mobileAreaCode
      this.showPicker = false
    },
    async genOpenidByWechatCode() {
      let res = await genOpenidByWechatCode({
        appId: this.wxAppId,
        wechatCode: this.wxCode,
      })
      if (res.code == 0) {
        this.openId = res.data.openId
        const query = { ...this.$route.query }
        if (query.code) {
          delete query.code
          this.$router.replace({ query }).catch((e) => {})
        }
      }
    },
    /**
     * 提交表单
     */
    submit() {
      console.log(this.currentForm)
      if (this.buttonLoading) return
      if (!this.user_key) {
        this.login()
        return
      }
      this.$refs['current-form'].validate(async (valid) => {
        if (valid) {
          this.buttonLoading = true

          let partnerInfo = null,
            ownXuserid = 0
          if (!this.partnerSingle) {
            let userParams = {
              name: this.currentForm.name,
              compName: this.currentForm.compName,
              entityId: this.currentForm.entityId,
              department: this.currentForm.department,
              title: this.currentForm.title,
              companyNatureId: this.currentForm.companyNatureId,
              companyNatureOtherTagName: this.currentForm.companyNatureOtherTagName,
            }
            let res = await Auserinfo(userParams)
            if (res.code == 0) {
              let user = { ...this.user }
              user.name = this.currentForm.name
              user.compName = this.currentForm.compName
              user.entityId = this.currentForm.entityId
              user.department = this.currentForm.department
              user.title = this.currentForm.title
              user.companyNatureId = this.currentForm.companyNatureId
              user.companyNatureOtherTagName = this.currentForm.companyNatureOtherTagName
              this.$store.commit('updateUser', user)
            }
          } else {
            ownXuserid = this.currentPartner.xuserid //同行人
            partnerInfo = {
              name: this.currentForm.name,
              compName: this.currentForm.compName,
              entityId: this.currentForm.entityId,
              department: this.currentForm.department,
              title: this.currentForm.title,
              companyNatureId: this.currentForm.companyNatureId,
              companyNatureOtherTagName: this.currentForm.companyNatureOtherTagName,
              mobile: this.currentForm.mobile,
              mobileAreaCode: this.currentForm.mobileAreaCode,
              mobileVerifyCode: this.currentForm.mobileVerifyCode,
            }
          }

          let { activityTicketId, ...params } = this.currentForm

          let ticketParamsStr = JSON.stringify(params)
          let pay_type = this.currentTicket.type == 1 ? 0 : this.isWeixinBrowser ? 1 : 2
          let order = await vbefGenOrder({
            activityTicketId: activityTicketId,
            checkFormJson: ticketParamsStr,
            payType: pay_type,
            loginPlatform: 7,
            openId: pay_type == 1 ? this.openId : '',
            ownXuserid,
            partnerInfo,
          })
          this.buttonLoading = false
          if (order.code == 0) {
            if (pay_type == 1) {
              this.payOrderId = order.data.activityOrderId
              this.invokeWeChatPay(order.data.jsapiResult)
            } else if (pay_type == 2) {
              let currentHref = `${this.vbef_path}/signUp?pay_status=1&order_id=${order.data.activityOrderId}`
              currentHref = encodeURIComponent(currentHref)
              window.location = order.data.wxPayMpOrderH5Url + `&redirect_url=${currentHref}`
            } else if (pay_type == 0) {
              this.$notify({
                type: 'success',
                message: filter.dealLanguage('报名成功！', 'Registration successful!'),
              })
              if (this.partnerSingle) {
                this.$router.push({
                  name: 'myTickets',
                })
                return
              }
              this.$router.push({
                name: 'ticketDetail',
                params: { id: order.data.activityTicketUserRelationId },
              })
            }
          } else {
            this.$notify(filter.dealLanguage(order.msg, order.enMsg || order.msg))
          }
        } else {
          this.$notify(
            filter.dealLanguage('请完善表单后提交', 'Please complete the form and submit it')
          )
        }
      })
    },
    async orderStatus() {
      let res = await orderStatus({
        id: this.payOrderId,
      })
      if (res.code == 0) {
        if (res.data.status == 2) {
          this.$notify({
            type: 'success',
            message: filter.dealLanguage('购买成功！', 'Purchase successful!'),
          })
          clearInterval(this.orderInv)
          if (this.partnerSingle) {
            this.$router.push({
              name: 'myTickets',
            })
            return
          }
          this.$router.push({
            name: 'ticketDetail',
            params: { id: res.data.activityTicketUserRelationId },
          })
        }
      }
    },
    invokeWeChatPay(params) {
      if (typeof WeixinJSBridge == 'object' && typeof WeixinJSBridge.invoke == 'function') {
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest',
          {
            // 这些参数应由后端提供
            appId: this.wxAppId,
            timeStamp: params.timeStamp,
            nonceStr: params.nonceStr,
            package: params.packageValue,
            signType: params.signType, // 或者其他签名方式，如"RSA"
            paySign: params.paySign,
          },
          (res) => this.handlePaymentResponse(res)
        )
      } else {
        // 处理WeixinJSBridge不可用的情况
        console.error('WeixinJSBridge is not available.')
      }
    },
    handlePaymentResponse(res) {
      if (res.err_msg == 'get_brand_wcpay_request:ok') {
        // 支付成功处理逻辑
        this.orderInv = setInterval(() => {
          this.orderStatus()
        }, 1000)
      } else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
        // 支付取消处理逻辑
        this.$notify(filter.dealLanguage('取消支付', 'Cancel payment'))
      } else if (res.err_msg == 'get_brand_wcpay_request:fail') {
        // 支付失败处理逻辑
        this.$notify(filter.dealLanguage('支付失败，请重试', 'Payment failed, please try again'))
      } else {
        // 其他情况处理逻辑
        console.log('Unknown payment response.', res)
      }
    },
    onBridgeReady() {
      // WeixinJSBridge 已经准备好了，可以进行后续操作
      console.log('WeixinJSBridge is ready.')
      // 这里可以调用需要Bridge就绪后才能执行的方法，例如this.invokeWeChatPay()
    },
    checkAndInitBridge() {
      // 微信浏览器
      if (typeof WeixinJSBridge == 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady)
          document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady)
        }
      } else {
        this.onBridgeReady()
      }
    },

  },
  watch: {
    needother() {
      this.currentForm.needother = ''
    },
    serviceother() {
      this.currentForm.serviceother = ''
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-m.styl'
@import '~styles/form-view-m.styl'
@import '~styles/ticket-item-m.styl'
.form-view
  .companions
    height 0.6rem
    margin-left 0.2rem
    display flex
    flex-direction column
    justify-content center
    >>> .ivu-checkbox-wrapper
      white-space nowrap
      color #1890ff
      margin-right 0
    >>> .ivu-select
      margin-top 0.1rem
      .ivu-select-selection
        height 28px
        .ivu-select-placeholder, .ivu-select-selected-value
          padding-left 10px
          height 26px
          line-height 26px
  .mobile-ipt
    display flex
    align-items center
    .area-number
      color #333333
      cursor pointer
      white-space nowrap
      height 0.88rem
      line-height 0.88rem
      padding 0 0 0 15px
      background #f9f9f9
      border-radius 4px 0 0 4px
      &.dis
        background #f0f0f0
    >>> .ivu-input
      border-radius 0 4px 4px 0
.skeleton-warpper
  padding-top 0.4rem
.center-wrapper
  padding 0.3rem 0.4rem 0
  .top-tip
    font-size 0.26rem
    color #3D3D3D
    line-height 0.48rem
    text-align justify
    a, span
      color #FA5A00
  .form-view
    padding 0.4rem 0 2.2rem
  .ticket-list
    .ticket-container
      &::before, &::after
        width 0.15rem
        height 1.28rem
    >>> .ivu-radio-group
      display flex
      flex-wrap wrap
      .ivu-radio-wrapper
        width 100%
        margin 0
        &:not(:first-of-type)
          margin-top 0.2rem
      .ivu-radio
        position absolute
        margin-right 0
        z-index 2
        right 16px
        top 16px
      .ticket-item-top-right .title
        padding-right 24px
      .ivu-radio-wrapper-checked
        .ivu-radio-inner
          border-color #FA5A00
        .ticket-container
          border-color #FA5A00
          &::before, &::after
            background-image url('~pic/ticket-bg-pc-active.png')
      .ivu-radio-focus
        box-shadow 0 0 2px rgba(255, 136, 36, 0.4)
      .ivu-radio-inner
        border-color #ffe6d1
        &:after
          background-color #FA5A00
      span.ivu-radio+*
        margin 0
.pay-type-btn
  display flex
  justify-content space-between
  align-items center
  margin-top 0.3rem
  height 0.88rem
  padding 0 0.2rem
  background #F9F9F9
  border-radius 0.2rem
  .select
    width 0.3rem
    height 0.3rem
  .pay-info
    display flex
    align-items center
    img
      width 0.4rem
      height 0.4rem
    .sp1
      margin-left 0.1rem
      font-size 0.28rem
      color #333333
    .sp2
      margin-left 0.1rem
      font-size 0.24rem
      color #999999
.btn-wrapper
  bottom 0
  z-index 10
  padding 0.2rem 0.4rem 0.64rem
  background #FFFFFF
  box-shadow 0rem -0.04rem 0.1rem 0rem rgba(0, 0, 0, 0.1)
  display flex
  justify-content space-between
  align-items center
  .info
    line-height 1
    .info-p1
      font-size 0.28rem
      color #333333
      span
        color #ED4014
    .info-p2
      margin-top 0.08rem
      font-size 0.22rem
      color #666666
</style>